import InputView from '../../../../FormSteps/InputView'
import RegistrationFormPage from '../Base/RegistrationFormPage'

const RegistrationPage: InputView = ({path}) => (
  <RegistrationFormPage
    path={path}
    requirePassword={false}
    heading='Almost there...'
    metaTitle='Contact details - HeadBox'
    />
)

export default RegistrationPage
